<template lang="pug">
  v-container(fluid style="height: 500px; overflow-y: scroll")
    v-row.style(v-if="transactionDetail.amountToWallet" )
      v-col.text-start(cols="2") {{ $t('bankTransactionPage.credit') }} :
      v-col.text-start(cols="10") {{getCredit(transactionDetail.amountToWallet)}} €
    v-list(v-for="(item, idx) in transactionDetail.invoices" :key="idx" v-if="transactionDetail.invoices.length > 0" )
      v-subheader {{item.invoice.name}}
      v-list-item
        v-list-item-content
          v-list-item-title {{ $t('bankTransactionPage.datePeriodStart') }} - {{ $t('bankTransactionPage.datePeriodEnd') }}
        v-list-item-content
          v-list-item-title.text-end {{getFormattedDate(item.invoice.periodStart)}} - {{getFormattedDate(item.invoice.periodEnd)}}
      v-list-item
          v-list-item-content
            v-list-item-title {{ $t('bankTransactionPage.amountPayed') }}
          v-list-item-content
            v-list-item-title.text-end  {{getInvoices(item.amountPayed)}} €
      v-list-item
          v-list-item-content
            v-list-item-title {{ $t('bankTransactionPage.priceItemSum') }}
          v-list-item-content
            v-list-item-title.text-end {{getInvoices(item.invoice.priceItemSum)}}  €
      v-list-item
          v-list-item-content
            v-list-item-title {{ $t('bankTransactionPage.priceTotal') }}
          v-list-item-content
            v-list-item-title.text-end {{getInvoices(item.invoice.priceTotal)}} €
      v-divider
    v-row(v-if="!transactionDetail.invoices.length > 0" )
      v-col(cols="12").title.text-center {{ $t('bankTransactionPage.invoicesErrorMessage') }}

</template>

<script lang="ts">
import Vue from "vue"
import {Component, Prop} from 'vue-property-decorator'
import BankTransaction from "@/model/BankTransaction/BankTransaction";
import moment from "moment/moment";

@Component({
  components: {
  }
})

export default class BankTransactionAmountToWalletTab extends Vue {
  @Prop({type: Object, required: false}) readonly transactionDetail!: BankTransaction


  getFormattedDate (item: string): string {
    return moment(item).format('D.M.YYYY')
  }
  getInvoices (invoices: number) {
    if(invoices){
      return (invoices / 100).toFixed(2)
    } else {
      return 0
    }
  }
  getCredit (amountToWallet: number) {
    if(amountToWallet){
      return amountToWallet / 100
    }
  }



  onCloseButtonClick(){
    this.$emit('close')
  }

  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
.style
  color: green
</style>
